import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Typography, Icon, Button } from "@ann/web-components";
import { FinishContainer, TextContainer, SubtitleContainer, ButtonsContainer } from "./Finish.styled";

const Finish = ({ invitedUsersCount = 1, breadcrumbHelpers }) => {
  const navigate = useNavigate();
  const isSingular = invitedUsersCount === 1;

  useEffect(() => {
    breadcrumbHelpers?.setPageBreadcrumb?.("Users", "Invite users", {
      pageHref: "/v2/user-management",
      subHref: "/v2/user-management/invite-user",
    });
  }, [breadcrumbHelpers]);

  return (
    <FinishContainer>
      <Icon
        color="success"
        name="checkCircle"
        size="large"
      />

      <TextContainer>
        <Typography category="title" size="large" weight="bold">
          {isSingular ? "Invite Sent" : "Invites Sent"}
        </Typography>

        <SubtitleContainer>
          <Typography category="body" size="medium" weight="regular">
            We've emailed invitations to {invitedUsersCount} {isSingular ? "user" : "users"}.
          </Typography>

          <Typography category="body" size="medium" weight="regular">
            They'll appear in the Users list after they accept. You can update their permissions anytime in Users.
          </Typography>
        </SubtitleContainer>

        <ButtonsContainer>
          <Button
            label="Invite more user"
            size="large"
            type="secondary"
            onClick={() => navigate("/v2/user-management/invite-user")}
          />
          <Button
            label="Go to users"
            size="large"
            type="primary"
            onClick={() => navigate("/v2/user-management")}
          />
        </ButtonsContainer>
      </TextContainer>
    </FinishContainer>
  );
};

export default Finish;

